import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CalendarModule, DateAdapter } from "angular-calendar";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";
import { SharedModule } from "../../shared/shared.module";
import { SalesScheduleDashboardRoutingModule } from "./sales-schedule-dashboard-routing.module";
import { SalesScheduleDashboardComponent } from "./sales-schedule-dashboard.component";

@NgModule({
    declarations: [SalesScheduleDashboardComponent],
    imports: [
        CommonModule,
        SharedModule,
        SalesScheduleDashboardRoutingModule,
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory
        })
    ]
})
  export class SalesScheduleDashboardModule {
  }